import { FormControl, FormErrorMessage, FormLabel } from "@chakra-ui/react";
import { Select } from "chakra-react-select";
import { FieldError } from "react-hook-form";

interface IOptions {
  label: string;
  value?: string;
  icon?: any;
}

type Props = {
  name: string;
  options: IOptions[];
  placeholder: string;
  label?: string;
  error?: FieldError;
  isLoading?: boolean;
  onChange?: (value: any) => void;
  isDisabled?: boolean;
  defaultValue?: IOptions;
  width: string;
  value?: object;
  ref?: any;
};

export function InputSelect({
  options,
  placeholder,
  label,
  error,
  name,
  isLoading = false,
  onChange,
  isDisabled = false,
  defaultValue,
  width,
  value,
  ref,
}: Props) {
  return (
    <FormControl isInvalid={!!error}>
      {label && (
        <FormLabel color="gray.800" htmlFor={name}>
          {label}
        </FormLabel>
      )}
      <Select
        ref={ref}
        name={name}
        size="sm"
        onChange={onChange}
        isLoading={isLoading}
        loadingMessage={() => "Carregando..."}
        noOptionsMessage={() => "Sem opções"}
        focusBorderColor="green.400"
        selectedOptionStyle="check"
        variant="flushed"
        placeholder={placeholder}
        options={options}
        isDisabled={isDisabled}
        defaultValue={defaultValue}
        value={value}
        chakraStyles={{
          control: (provided) => ({
            ...provided,
            borderBottomColor: "#475569",
            borderBottomWidth: 2,
            mt: -3,
            width: width,
          }),
        }}
      />
      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
}
